import { ItemView } from '../../models/item-view.model';
import { KnownTabIds, TabItem } from '../../models/tab-item.model';

interface TabListModelInit {
    readonly id: string;
    readonly area: string;
    readonly tabs: Array<TabItem>;
    readonly logImpression: (items: Array<any>, listId: KnownTabIds, numRenderedItems: number, itemView: ItemView, fromCache: boolean, state: TabItemState) => void;
    readonly tabActivationAriaLabel?: string; // Expected format string with {0} being title of the tab to be read out by Narrator; and {1} being the number of items rendered
    readonly tabClass?: string;
    readonly defaultTab?: number;
    readonly headerText?: string;
}

// See: https://stackoverflow.com/questions/48495665/extending-this-in-typescript-class-by-object-assign
export interface TabListModel extends TabListModelInit {}

export class TabListModel implements TabListModelInit {
    // Callback handlers which are called when new tab is added or updated
    private readonly onTabAddedOrUpdated = new Array<(tabItem: TabItem, index: number, existingTab: boolean) => void>();

    constructor(init: TabListModelInit) {
        Object.assign(this, init);
    }

    public updateOrAddTab(tabItem: TabItem, position: number = -1) {
        const tabs = this.tabs;

        let existingTab = false;
        let tabIndex = tabs.length;
        for (let i = 0; i < tabs.length; i++) {
            const tabId = tabs[i].id;
            if (tabId === tabItem.id) {
                existingTab = true;
                tabIndex = i;
                tabs[i] = tabItem;
                break;
            }
        }

        if (!existingTab) {
            if (position === -1 || position >= tabs.length) {
                tabs.push(tabItem);
            } else {
                tabs.splice(position, 0, tabItem);
            }
        }

        for (const handler of this.onTabAddedOrUpdated) {
            handler(tabItem, tabIndex, existingTab);
        }
    }

    public registerOnTabAddedOrUpdated(handler: (tabItem: TabItem, index: number, existingTab: boolean) => void) {
        this.onTabAddedOrUpdated.push(handler);
    }
}

export enum TabItemState {
    Unknown,
    Loading,
    Loaded,
    Error
}
